import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';

import { IStudyGroupMember, IStudyGroupPriorityFeedCard } from '../study_group_interfaces';

export class StudyGroupPriorityFeedCardBuilder implements IIndexable {
  id: string;
  content_type: 'study.buddy';
  title: string;
  description: string;
  constructor(source: IStudyGroupPriorityFeedCard) {
    return _4.merge(this, source);
  }
  static build(source: IStudyGroupPriorityFeedCard) {
    return new StudyGroupPriorityFeedCardBuilder(source);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/builders/study_group_priority_feed_builder.ts